import type { PropsWithChildren } from "react";
import React from "react";
import {
  getTenancyRecoverySnapshot,
  subscribeToTenancyRecovery,
  TENANCY_FORBIDDEN_CODE,
} from "./recovery";
import { TenancyDialog } from "./TenancyDialog";

export const TenancyRecoveryProvider = ({ children }: PropsWithChildren) => {
  const recovery = React.useSyncExternalStore(
    subscribeToTenancyRecovery,
    getTenancyRecoverySnapshot,
    getTenancyRecoverySnapshot,
  );

  return (
    <>
      {children}
      <TenancyDialog
        open={recovery.required}
        blocking
        forbidden={recovery.reason === TENANCY_FORBIDDEN_CODE}
      />
    </>
  );
};
